import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  VpHookFormWrapper,
  VpAutoSave,
  VpMediaTitleInput,
  VpMediaDescriptionInput,
  VpMediaTranscriptionInput,
  VpMediaCaptionInput,
  VpMediaFileSizeInput,
  VpMediaNameInput
} from '@vp-ui';
import { useUpdateMediaDetails } from '@src/hooks';
import { getFileSizeLabel, extractThumbnailPath } from '@src/utils';
import { useUpdateAttachmentDetails } from '@src/hooks/react-query/useAttachmentData';

export const VpMediaInfoDetails = ({ media, showCaptions = true }) => {
  const isVideo = !!media?.mediaId;
  const fileSizeLabel = !isVideo && getFileSizeLabel(media?.fileSize);

  const { mutate: updateMediaData } = useUpdateMediaDetails();
  const { mutate: updateAttachmentData } = useUpdateAttachmentDetails();

  const defaultValues = {
    title: media?.mediaTitle || media?.attachmentTitle,
    description: media?.mediaDescription || media?.attachmentDescription,
    thumbnailUrl: media?.thumbnailUrl
  };

  const onSubmit = (values) => {
    const data = {
      title: values?.title || '',
      description: values?.description || ''
    };
    if (isVideo) {
      const thumbnailToUse = values?.thumbnailUrl || media?.thumbnailUrl;
      const thumbnailUrl = extractThumbnailPath(thumbnailToUse);
      data.thumbnailUrl = thumbnailUrl;
      updateMediaData({ data, mediaId: media?.mediaId });
    } else {
      updateAttachmentData({ data, attachmentId: media?.attachmentId });
    }
  };
  const defaultInputFields = (
    <>
      <VpMediaTitleInput defaultValue={media?.mediaTitle || media?.attachmentTitle} />
      <VpMediaDescriptionInput
        defaultValue={media?.mediaDescription || media?.attachmentDescription}
      />
    </>
  );
  return (
    <VpHookFormWrapper onSubmit={onSubmit}>
      {defaultInputFields}
      {isVideo ? (
        <>
          <VpMediaTranscriptionInput media={media} />
          {showCaptions && <VpMediaCaptionInput media={media} />}
        </>
      ) : (
        <>
          <VpMediaNameInput value={media?.originalFileName} />
          <VpMediaFileSizeInput value={fileSizeLabel} />
        </>
      )}
      <VpAutoSave onSubmit={onSubmit} defaultValues={defaultValues} />
    </VpHookFormWrapper>
  );
};

VpMediaInfoDetails.propTypes = {
  media: PropTypes.shape({
    attachmentTitle: PropTypes.string,
    mediaTitle: PropTypes.string,
    mediaDescription: PropTypes.string,
    attachmentDescription: PropTypes.string,
    mediaUrl: PropTypes.string,
    mediaId: PropTypes.string,
    thumbnailUrl: PropTypes.string,
    path: PropTypes.string,
    attachmentId: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.object),
    originalFileName: PropTypes.string,
    fileSize: PropTypes.string
  }),
  showCaptions: PropTypes.bool,
  contentTaggingEnabled: PropTypes.bool
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(VpMediaInfoDetails);



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/VpMediaSubmissionDetailsDialog/VpMediaInfoDetails.jsx